jQuery.getScriptAndCache = function (url, options) {

	// allow user to set any option except for dataType, cache, and url

	options = $.extend(options || {}, {
		dataType: 'script',
		cache: true,
		url: url
	});

	// use $.ajax() since it is more flexible than $.getScript
	// return the jqXHR object so we can chain callbacks

	return jQuery.ajax(options);

};

jQuery.getStyleAndCache = function (url, options) {

	// allow user to set any option except for dataType, cache, and url

	options = $.extend(options || {}, {
		dataType: 'text',
		cache: true,
		url: url
	});

	// use $.ajax() since it is more flexible than $.getScript
	// return the jqXHR object so we can chain callbacks

	return jQuery.ajax(options);

};

var mapBox = {



	elements: $('[data-mapbox]'),



	pop: null,



	pin: null,



	instances: {},



	init: function () {



		if (mapBox.elements.length) {



			$.getScriptAndCache('https://api.mapbox.com/mapbox-gl-js/v0.47.0/mapbox-gl.js').done(function (script, textStatus) {



				$.getStyleAndCache('https://api.mapbox.com/mapbox-gl-js/v0.47.0/mapbox-gl.css').done(function (style, textStatus) {



					$('<style>\n' + style + '</style>').appendTo('head');    



					mapBox.elements.each(function (index) {



						var target = $(this),

						varName = target.attr('data-mapbox'),

						data = window[varName] || false;



						if (data) {



							mapboxgl.accessToken = data.apikey;

							if (data.apikey || false) delete data.apikey;



							var name = 'mapbox-' + varName + '-' + index;

							target.attr('id', name);

							data.container = name;



							var pins = data.pins || false;

							if (pins) { delete data.pins; }



							if (site.isTouch() && window.matchMedia('(max-width: ' + (site.bp.desktop - 1) + 'px)').matches) { data.dragPan = false; }



							mapBox.instances[name] = new mapboxgl.Map(data);

							mapBox.instances[name].scrollZoom.disable();

							mapBox.instances[name].addControl(new mapboxgl.NavigationControl({ showCompass: false }));



							if (pins) {



								$.each(pins.features, function (index, marker) {



									var title = $($.parseHTML(marker.properties.message)[0]).html();



									var element = $('<div class="m-mapbox__pin t-mapbox-pin" />');



									element.attr('tabindex', 0);

									element.attr('role', 'link');

									element.attr('aria-label', title);



									element.on('click keypress', function (e) {



										if ((e.type == 'keypress') && (e.which !== 13)) { return false; } // bail out for keypress unless enter key



										mapBox.pin = $(this); // cache active pin



										setTimeout(function () {



											mapBox.pop = new mapboxgl.Popup({ offset: [0, -60], anchor: 'bottom' }).setLngLat(marker.geometry.coordinates).setHTML('<div class="m-mapbox__popup" tabindex="0"><div class="cms">' + marker.properties.message + '</div><div class="m-mapbox__popup__focus-loop" tabindex="0"></div></div>').addTo(mapBox.instances[name]);

											var px = mapBox.instances[name].project(mapBox.pop._lngLat); // find the pixel location on the map where the popup anchor is

											px.y -= (mapBox.pop._container.clientHeight + 60) / 2 // find the height of the popup container, divide by 2, subtract from the Y axis of marker location

											mapBox.instances[name].panTo(mapBox.instances[name].unproject(px), { animate: true }); // pan to new center



											$('.m-mapbox__popup').focus();



											$('.m-mapbox__popup__focus-loop').focus(function () {

												$(this).closest('.m-mapbox__popup').prev('.mapboxgl-popup-close-button').focus();

											});



											mapBox.pop.on('close', function () { mapBox.pin.focus(); }); // focus on last active pin



										}, 100);



									});



									new mapboxgl.Marker(element[0]).setLngLat(marker.geometry.coordinates).addTo(mapBox.instances[name]);



								});



							}



						} else {



							console.log('No valid data for map ' + varName);



						}



					});



					site.doc.keyup(function (e) {



						if (e.keyCode == 27) {



							if (utils.checkOnScreen(mapBox.elements.get(0))) {



								if (mapBox.pop) { mapBox.pop.remove(); }



							}



						}



					});



				});



			});



		}



	}



};



$(function () {

	mapBox.init();

});